var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.1671 6.10003C13.8404 5.58003 13.4671 5.11336 13.0804 4.69336L10.5671 7.20669C10.6471 7.45336 10.6937 7.72003 10.6937 8.00003C10.6937 9.49336 9.48706 10.6934 8.00039 10.6934C7.72039 10.6934 7.45372 10.6467 7.20706 10.5667L4.90039 12.8734C5.87372 13.42 6.92706 13.7067 8.00039 13.7067C9.18706 13.7067 10.3404 13.36 11.3937 12.7134C12.4471 12.06 13.3937 11.1067 14.1671 9.89336C14.8337 8.85336 14.8337 7.14669 14.1671 6.10003Z",
    fill: "#AEB8D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34708 6.65332L6.65375 9.34666C6.31375 8.99999 6.09375 8.51999 6.09375 7.99999C6.09375 6.95332 6.94708 6.09332 8.00042 6.09332C8.52042 6.09332 9.00042 6.31332 9.34708 6.65332Z",
    fill: "#AEB8D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.1663 3.83335L9.90634 6.09335C9.41968 5.60001 8.74634 5.30668 7.99968 5.30668C6.50634 5.30668 5.30634 6.51335 5.30634 8.00001C5.30634 8.74668 5.60634 9.42001 6.09301 9.90668L3.83968 12.1667H3.83301C3.09301 11.5667 2.41301 10.8 1.83301 9.89335C1.16634 8.84668 1.16634 7.14668 1.83301 6.10001C2.60634 4.88668 3.55301 3.93335 4.60634 3.28002C5.65968 2.64002 6.81301 2.28668 7.99968 2.28668C9.48634 2.28668 10.9263 2.83335 12.1663 3.83335Z",
    fill: "#AEB8D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90672 7.99999C9.90672 9.04666 9.05339 9.90666 8.00005 9.90666C7.96005 9.90666 7.92672 9.90666 7.88672 9.89332L9.89339 7.88666C9.90672 7.92666 9.90672 7.95999 9.90672 7.99999Z",
    fill: "#AEB8D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5136 1.48667C14.3136 1.28667 13.9869 1.28667 13.7869 1.48667L1.48691 13.7933C1.28691 13.9933 1.28691 14.32 1.48691 14.52C1.58691 14.6133 1.71358 14.6667 1.84691 14.6667C1.98025 14.6667 2.10691 14.6133 2.20691 14.5133L14.5136 2.20667C14.7203 2.00667 14.7203 1.68667 14.5136 1.48667Z",
    fill: "#AEB8D5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.532bb452.svg";
export { ForwardRef as ReactComponent };